import { useField } from 'react-final-form'
import { composeValidators, selectRequired } from '../../utilities/validate'
// import { useType } from './multiSelectType'

export type FieldRequired = boolean | { showAsterisk?: boolean; triggedValidate?: boolean; errorMessage?: string }

const useMultiSelect = (props: any) => {
    const { name, required, validates = [] } = props
    let mergeValidate = validates
    if ((typeof required === 'boolean' && required) || (typeof required === 'object' && required.triggedValidate)) {
        mergeValidate = [
            selectRequired(typeof required === 'object' ? required.errorMessage : undefined),
            ...mergeValidate,
        ]
    }

    const field = useField<any>(name, {
        validate: composeValidators(...mergeValidate),
    })

    return { field }
}

export default useMultiSelect
